module.exports = __webpack_public_path__ + "static/media/custom-04.369c19af.jpg";